import { render, staticRenderFns } from "./validators-dropdown.vue?vue&type=template&id=51b7134d&scoped=true&"
import script from "./validators-dropdown.vue?vue&type=script&lang=ts&"
export * from "./validators-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b7134d",
  null
  
)

export default component.exports